import { Injectable } from '@angular/core';
import { ComponentLocationStrategy } from './component-location-strategy';

@Injectable()
export class GebaeudeSuchergebnisLocationStrategy extends ComponentLocationStrategy {
  constructor() {
    super();
  }

  componentId(): string {
    return 'GEBAEUDE_SUCHERGEBNIS';
  }
}
